import { useEffect, useState } from 'react';

/**
 * Tracks browser connectivity via the `online`/`offline` events.
 *
 * Note: `navigator.onLine === true` only means the device has a network
 * interface up, not that the API is reachable — but `false` is a reliable
 * signal that we are offline, which is what the offline UX keys off.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = (): void => setOnline(true);
    const goOffline = (): void => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}

export default useOnlineStatus;
